import script from "./BuildersGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildersGrid.vue?vue&type=script&setup=true&lang=js"

import "./BuildersGrid.vue?vue&type=style&index=0&id=8cec31e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cec31e8"]])

export default __exports__